import { FC } from 'react';

import FacebookIcon from '@/assets/icons/icon_fb.svg';
import HatenaIcon from '@/assets/icons/icon_hatena.svg';
import LineIcon from '@/assets/icons/icon_line.svg';
import XIcon from '@/assets/icons/icon_x.svg';

import {
  LinksWrapper,
  OpinionArea,
  OpinionLink,
  ShareArea,
  Wrapper,
} from './style';

enum SNS {
  facebook = 'facebook',
  twitter = 'twitter',
  line = 'line',
  hatena = 'hatena',
}

interface ShareLinksProps {
  isShowOpinion?: boolean;
  nonPublic?: boolean;
}

const ShareLinks: FC<ShareLinksProps> = ({
  isShowOpinion = true,
  nonPublic,
}) => {
  const snsLinks: {
    icon: string;
    type: SNS;
    alt: string;
  }[] = [
    {
      icon: FacebookIcon,
      type: SNS.facebook,
      alt: 'Facebook',
    },
    {
      icon: XIcon,
      type: SNS.twitter,
      alt: 'Twitter',
    },
    {
      icon: LineIcon,
      type: SNS.line,
      alt: 'LINE',
    },
    {
      icon: HatenaIcon,
      type: SNS.hatena,
      alt: 'はてなブックマーク',
    },
  ];

  const getShareUrl = (type: SNS) => {
    const url = encodeURIComponent(window.location.href);
    const title = encodeURIComponent(document.title);

    switch (type) {
      case SNS.facebook: {
        return `https://www.facebook.com/share.php?u=${url}`;
      }
      case SNS.twitter: {
        return `https://twitter.com/share?url=${url}&text=${title}&hashtags=DMM競輪`;
      }
      case SNS.line: {
        return `https://social-plugins.line.me/lineit/share?url=${url}`;
      }
      case SNS.hatena: {
        return `https://b.hatena.ne.jp/entry/panel/?url=${url}&btitle=${title}`;
      }
    }
  };

  return (
    <Wrapper>
      {isShowOpinion && (
        <OpinionArea>
          <OpinionLink
            href="https://docs.google.com/forms/d/e/1FAIpQLSfJ-ahznKNnl7aFr_u2oHzVaNDEzew4Ovi3Q5gGFEEAP_llwQ/viewform"
            target="_blank"
          >
            ご意見・ご要望はこちら
          </OpinionLink>
        </OpinionArea>
      )}
      {!nonPublic && (
        <ShareArea>
          <p>この記事をシェアする</p>
          <LinksWrapper>
            {snsLinks.map(sns => (
              <a href={getShareUrl(sns.type)} target="_blank" key={sns.type}>
                <img src={sns.icon} alt={sns.alt} />
              </a>
            ))}
          </LinksWrapper>
        </ShareArea>
      )}
    </Wrapper>
  );
};

export default ShareLinks;
